import React from 'react';
import Header from '../header/Header';
import ApplicationWrapper from '../boundaries/ApplicationWrapper';
import Footer from '../footer/Footer';
import ModalAggregate from '../modals/ModalAggregate';
import logoImg from '../../assets/images/logoBck.svg';
import { InitializationBoundary } from '../boundaries/InitializationBoundary';
import { useAppTranslation } from '../../i18n';

export const MainLayout = () => {
	const { t } = useAppTranslation();

	return (
		<div className="App">
			<a href="#main-content" className="skip-link">
				{t('a11y.skip-to-content')}
			</a>
			<div className="App-center" style={backgroundStyle}>
				<InitializationBoundary>
					<div className="App-wrapper">
						<Header />
						<main id="main-content">
							<ApplicationWrapper />
						</main>
					</div>
					<Footer />
				</InitializationBoundary>
			</div>
			<ModalAggregate />
		</div>
	);
};

const backgroundStyle = {
	backgroundImage: `url(${logoImg})`,
	backgroundRepeat: 'no-repeat',
	backgroundPosition: 'center',
	backgroundSize: '1300px 900px',
	backgroundPositionX: '-550px',
	backgroundPositionY: '-50px'
};
